/* Component Dependencies */
var phoneReservationsTemplate = require('templates/phoneReservations.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'phoneReservations',
  template: {
    'phoneReservations': phoneReservationsTemplate
  },
  subscribe: {
    'TOGGLE_PHONE_RESERVATIONS': 'togglePhoneReservations'
  },
  /**
   * This method is called to show or hide when more Options is
   * clicked on Option Widget tile on confirmation page
   */
  togglePhoneReservations : function _togglePhoneReservations(){
    var _self=this;
    _self.$el.hasClass('l-display-none')?_self.$el.removeClass('l-display-none').addClass('l-display-block'):_self.$el.removeClass('l-display-block').addClass('l-display-none');
  }
});
